import { render, staticRenderFns } from "./editLook.vue?vue&type=template&id=683a5cd3"
import script from "./editLook.vue?vue&type=script&lang=js"
export * from "./editLook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports